import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import {withRouter} from "react-router-dom"
import { compose } from 'recompose';
import { Row, Col, Card, CardBody, Button } from 'reactstrap';
import { Star } from 'react-feather';

import { withFirebase } from '../../services/Firebase';
import ReportsPage from '../reports/ReportsPage';
import MeetingCard from './components/UpcomingMeeting';
import LatestActivities from "./components/LatestActivities";
import LatestContent from "./components/LatestContent";
import "../../assets/scss/pages/dashboard.scss";
import { observable } from 'mobx';

let $primary = "#7367F0",
  $danger = "#EA5455",
  $warning = "#FF9F43",
  $info = "#00cfe8",
  $primary_light = "#9c8cfc",
  $warning_light = "#FFC085",
  $danger_light = "#f29292",
  $info_light = "#1edec5",
  $stroke_color = "#e8e8e8",
  $label_color = "#e7eef7",
  $white = "#fff"

// Need to Change - Grid alignment Changes when content renders

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  navigateTo = page => {
    this.props.history.push(page);
  }

  render() {
    return (
      <div className="dashboard">
        <div className="grid-container">
          {/*--------------------BLOCK 1---------------------*/}
          <div className="block1">
            <Card className="card">
              <CardBody className="blockABody">
                <div className="d-flex justiy-content-between">
                  <div>
                    <h4 style={{color: "#fff"}}>Good Morning</h4>
                    <p>Learn new features and grow your business.</p>
                    <Button
                      color="primary"
                      className="btn btn-sm"
                    >
                        Take A Tour
                    </Button>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
          {/*--------------------BLOCK 2---------------------*/}
          <div className="block block2">
            <Card className="card">
              <h3>Announcements</h3>
              <CardBody>
                <div className="d-flex justify-content-center align-items-center" style={{height: "100%"}}>
                  <span className="text-muted text-center mt-2">
                    No Announcements.
                  </span>
                </div>
                
              </CardBody>
            </Card>
          </div>
          {/*--------------------BLOCK 3---------------------*/}
          <div className="block block3">
            <Card className="card">
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                <h3 className="mb-0">Appointments</h3>
                <p className="viewAllText" onClick={() => { this.navigateTo("/calendar") }} >View All</p>
              </div>
              <CardBody>
                <MeetingCard />
              </CardBody>
            </Card>
          </div>
          {/*--------------------BLOCK 4---------------------*/}
          <div className="block block4">
            <Card className="card">
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                <h3 className="mb-0">Activities</h3>
                <p className="viewAllText" onClick={()=>{this.navigateTo("/activity")}} >View All</p>
              </div>
              <CardBody>
                <LatestActivities />
              </CardBody>
            </Card>
          </div>
          {/*--------------------BLOCK 5---------------------*/}
          <div className="block block5">
            <Card className="card">
              <h3>Customer Engagement</h3>
              <CardBody>
                <div className="d-flex justify-content-center align-items-center" style={{height: "100%"}}>
                  <span className="text-muted text-center mt-2">
                    No Customer Engagement to show.
                  </span>
                </div>
              </CardBody>
            </Card>
          </div>
          {/*--------------------BLOCK 6---------------------*/}
          <div className="block block6">
            <Card className="card">
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                <h3 className="mb-0">Latest Content</h3>
                <p className="viewAllText" onClick={() => { this.navigateTo("/library") }} >View All</p>
              </div>
              <CardBody>
                <LatestContent />
              </CardBody>
            </Card>
          </div>

        </div>
      </div>
    );
  }
}

export default withRouter(Page);









// import React, { Component } from 'react';
// import { inject, observer } from 'mobx-react';
// import { compose } from 'recompose';
// import { Row } from 'reactstrap';

// import { withFirebase } from '../../services/Firebase';
// import ReportsPage from '../reports/ReportsPage';
// import MeetingCard from './Meeting';

// class Page extends Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       text: '',
//       loading: false,
//     };
//   }

//   componentDidMount() {
//     if (!this.props.messageStore.messageList.length) {
//       this.setState({ loading: true });
//     }

//     this.onListenForMessages();
//   }

//   componentDidUpdate(props) {
//     if (props.messageStore.limit !== this.props.messageStore.limit) {
//       this.onListenForMessages();
//     }
//   }

//   onListenForMessages = () => {
//     this.props.firebase
//       .messages()
//       .orderByChild('createdAt')
//       .limitToLast(this.props.messageStore.limit)
//       .on('value', snapshot => {
//         this.props.messageStore.setMessages(snapshot.val());

//         this.setState({ loading: false });
//       });
//   };

//   componentWillUnmount() {
//     this.props.firebase.messages().off();
//   }

//   onChangeText = event => {
//     this.setState({ text: event.target.value });
//   };

//   onCreateMessage = (event, authUser) => {
//     this.props.firebase.messages().push({
//       text: this.state.text,
//       userId: authUser.uid,
//       createdAt: this.props.firebase.serverValue.TIMESTAMP,
//     });

//     this.setState({ text: '' });

//     event.preventDefault();
//   };

//   onEditMessage = (message, text) => {
//     const { uid, ...messageSnapshot } = message;

//     this.props.firebase.message(message.uid).set({
//       ...messageSnapshot,
//       text,
//       editedAt: this.props.firebase.serverValue.TIMESTAMP,
//     });
//   };

//   onRemoveMessage = uid => {
//     this.props.firebase.message(uid).remove();
//   };

//   onNextPage = () => {
//     this.props.messageStore.setLimit(
//       this.props.messageStore.limit + 5,
//     );
//   };

//   render() {
//     const { messageStore, sessionStore } = this.props;
//     const { text, loading } = this.state;
//     const messages = messageStore.messageList;

//     return (
//       <Row>
//         <ReportsPage />
//         <MeetingCard />
//       </Row>
//     );
//   }
// }

// export default compose(
//   withFirebase,
//   inject('messageStore', 'sessionStore'),
//   observer,
// )(Page);
